import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable, of } from "rxjs";
import { switchMap, catchError } from "rxjs/operators";
import { DiagramComponentModalComponent } from "../components/diagram-component-modal/diagram-component-modal.component";
import { DiagramComponentService } from "./diagram-component.service";

@Injectable({
  providedIn: "root",
})
export class DiagramModalService {
  constructor(
    private dialog: MatDialog,
    private diagramComponentService: DiagramComponentService
  ) {}

  openComponentModal(componente: any, diagramaId: string, dadosDiagrama: any): Observable<any> {
    return this.diagramComponentService.getComponenteInfo(diagramaId, componente.id).pipe(
      switchMap((response) => {
        return this.dialog
          .open(DiagramComponentModalComponent, {
            width: "900px",
            maxWidth: "95vw",
            maxHeight: "90vh",
            panelClass: "diagram-component-dialog",
            data: {
              componente: componente,
              diagramaId: diagramaId,
              componenteInfo: response.componente,
              dadosDiagrama: dadosDiagrama,
            },
          })
          .afterClosed();
      }),
      catchError((error) => {
        console.error("Erro ao abrir modal do componente:", error);
        return of(null);
      })
    );
  }
}
